import { useMemo } from 'react';
import { isEmpty, isReservedColumn } from '../utils/index.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var GETKEY = "dataIndex";
var ResizableUniqIdPrefix = "resizable-col-id";
function getUniqueId(s) {
  return `${ResizableUniqIdPrefix}-${s}`;
}
function getColumns(list) {
  const trulyColumns = list == null ? void 0 : list.filter((item) => !isEmpty(item) || isReservedColumn(item));
  const c = trulyColumns == null ? void 0 : trulyColumns.map((col, index) => {
    var _a;
    if (isReservedColumn(col)) {
      return col;
    }
    return __spreadProps(__spreadValues({}, col), {
      children: ((_a = col == null ? void 0 : col.children) == null ? void 0 : _a.length) ? getColumns(col.children) : void 0,
      [GETKEY]: col[GETKEY] || col.key || getUniqueId(`${col.title}-${index}`)
    });
  });
  return c;
}
function useGetDataIndexColumns(columns) {
  const dataIndexColumns = useMemo(() => getColumns(columns), [columns]);
  return dataIndexColumns || columns;
}

export { GETKEY, ResizableUniqIdPrefix, getUniqueId, useGetDataIndexColumns };
